export default {
    monthly: 'Monthly',
    yearly: 'Yearly',
    month: 'month',
    year: 'year',
    title: 'Subscription Plans',
    current_plan: 'Current Plan',
    selected_plan: 'Selected Plan',
    status: 'Status',
    statuses: {
        active: 'Active',
        past_due: 'Past Due',
        canceled: 'Canceled',
    },
    cancel: 'Cancel Subscription',
    confirm_cancel: 'Are you sure you want to cancel your subscription?',
    available_plans: 'Available Plans',
    select_plan: 'Select Plan',
    features: {
        personalized_workouts: 'Personalized workouts',
        exercise_library: 'Exercise library',
        progress_tracking: 'Progress tracking',
        nutrition_guidance: 'Nutrition guidance',
        priority_support: 'Priority support',
    },
};
